// v2-compatible wrapper (now the default!)
const rfc6902v2Compat = require('./jsonPatchRfc6902v2Compat');

// Original v2 implementation - DEPRECATED (emergency rollback only)
const rfc6902Legacy = require('./jsonPatchRfc6902');

// Native v3 implementation
const rfc6902v3 = require('./jsonPatchRfc6902v3');

const applicationPatchHistory = require('./applicationPatchHistory');
const omit = require('lodash.omit');
const appHistory = omit(applicationPatchHistory, '_private');

module.exports = {
    /** @default v2-compatible (v3-powered) - full API */
    rfc6902: rfc6902v2Compat,
    /** ALIAS: Same as rfc6902 (for test compatibility) */
    rfc6902v2: rfc6902v2Compat,
    /** Native v3 - strict RFC 6902 compliance, modern features
    NOTE: Returns: { newDocument, removed } for apply() */
    rfc6902v3,
    /** @deprecated  Original v2 implementation (emergency rollback only)
     Use this ONLY if you find compatibility issues
     Will be removed after cross-silo testing confirms compatibility */
    rfc6902Legacy,
    appHistory
};
